async function getQueryStringFromObject(query = {}) {
    let queryString = '';
    for (let key in query) {
        if (query[key] === null || query[key] === undefined || query[key] === '') {
            continue;
        }
        query[key] = encodeURIComponent(query[key]);
        queryString += `${key}=${query[key]}&`;
    }
    return queryString;
}

async function convertHourMinuteSecondsToSeconds(time) {

    if (!time) {
        return 0;
    }

    time = String(time);
    
    let seconds = 0;
    try {
        let timeArray = time.split(':');
        for (let i = 0; i < timeArray.length; i++) {
            try {
                seconds += parseInt(timeArray[i]) * Math.pow(60, timeArray.length - i - 1);
            } catch (error) {
                console.error('Error in convertHourMinuteSecondsToSeconds: ', error);
                seconds += 0;
            }
        }
    } catch (error) {
        console.error('Error in convertHourMinuteSecondsToSeconds: ', error);
    }
    
    return seconds;
}

async function convertSecondsToHourMinuteSeconds(seconds='0') {
    
    try {
        seconds = parseInt(seconds);
    } catch (error) {
        console.error('Error in convertSecondsToHourMinuteSeconds: ', error);
        seconds = 0;
    }
    
    let time = '';


    try {
        let hours = Math.floor(seconds / 3600);
        let minutes = Math.floor((seconds % 3600) / 60);
        let secs = seconds % 60;
        // add hours, minutes and seconds only if they are greater than 0
        if (hours > 0) {
            time += hours + ':';
        }
        time += minutes + ':' + (secs < 10 ? '0' + secs : secs);
        return time;
    } catch (error) {
        console.error('Error in convertSecondsToHourMinuteSeconds: ', error);
    }
    return time;
}

export {
    getQueryStringFromObject,
    convertHourMinuteSecondsToSeconds,
    convertSecondsToHourMinuteSeconds
}